import { SxProps } from '@mui/material';
import { GLOBAL_MARGIN_HORIZONTAL } from 'src/app/constants';
import { brand } from 'src/themes/palette';

const container: SxProps = {
  flex: 1,
  width: '100%',
  display: 'flex',
  height: '100vh',
  flexDirection: 'column',
  paddingBottom: GLOBAL_MARGIN_HORIZONTAL,
};

const infoContainer: SxProps = {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
};

const addButton: SxProps = {
  height: 50,
  width: '50%',
  marginTop: 10,
  color: brand.tertiary,
  backgroundColor: brand.blue,
  borderRadius: 20,
};

export { container, infoContainer, addButton };
